
export default class AdditionalRequirement{

    constructor(jsonResponse) {
        this.name = jsonResponse["requirement-name"];
        this.type = jsonResponse["requirement-type"];
        this.displayName = jsonResponse["requirement-display-name"];
    }
}